module.exports = __webpack_public_path__ + "static/media/financeBuilding.c6522dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/financeBuilding.png
// module id = 197
// module chunks = 0